import { API_URL } from "../config/config";
import { putRequest } from "../utils/axiosUtils";

export const notificationCounterUpdate = async ({ userId, senderId, type = 'MESSAGE' }) => {
    if (!userId || !senderId) {
        throw new Error('UserId and senderId are required.');
    }

    const response = await putRequest({
        url: `${API_URL}/admin/user/notification-counter-update`,
        data: { userId, senderId, type },
    });

    if (response.status >= 200 && response.status < 300 && response.data) {
        return response.data;
    } else {
        const errorMessage = `Unexpected response code: ${response.status}`;
        throw new Error(errorMessage);
    }
};